import React, { useState } from 'react'
import { removeHTMLTags } from '../../../Utils/UI'

export const ReadMore = ({ data, limit, onClick, ...rest }) => {
    let cleanedData = removeHTMLTags(data)
    const [readMore, setReadMore] = useState(false)
    const toggleReadMore = () => {
        setReadMore(!readMore)
    }
    return (
        <>
            <p
                className={`${rest.className}${readMore ? ' show' : ''} ${
                    onClick ? 'cursorDecoy' : ''
                }`}
                onClick={onClick ? onClick : null}
            >
                {cleanedData.substring(0, readMore ? cleanedData.length : limit)}
                {!readMore && cleanedData.length > limit ? '...' : null}
            </p>
            {cleanedData.length > limit && (
                <a className="readMore cursorDecoy" onClick={toggleReadMore}>
                    See {readMore ? 'less' : 'more'}
                </a>
            )}
        </>
    )
}

export default ReadMore
